import React, {Component} from 'react';
import './HR.css';

class HR extends Component {
	render() {
		return (
			<hr className="HR"></hr>
		);
	}
}

export default HR;


// WEBPACK FOOTER //
// ./src/widgets/HR.js